/**
 * Dashboard tuning constants shared between backend (aggregation) and
 * frontend (display + TanStack Query staleness).
 *
 * Keep these in one place so a CO-driven product tweak (e.g. "show 12 months
 * of sparkline instead of 6") doesn't require hunting across the codebase.
 */

/** How many trailing months of net-flow data drive each KPI tile's sparkline. */
export const SPARKLINE_MONTHS = 6;

/** Latest-N transactions shown in the Private Spotlight ledger panel. */
export const DASHBOARD_LATEST_TX_LIMIT = 10;

/**
 * Default low-balance threshold (BDT) when a fund is missing from
 * `settings.low_balance_thresholds`. The settings JSON is the canonical
 * source of truth — this constant is only the fallback for misconfigurations.
 */
export const DEFAULT_LOW_BALANCE_THRESHOLD = 50_000;

/**
 * RAG band multiplier for the AMBER tier:
 *   RED   — balance ≤ threshold
 *   AMBER — threshold < balance ≤ threshold × RAG_AMBER_MULTIPLIER
 *   GREEN — balance > threshold × RAG_AMBER_MULTIPLIER
 */
export const RAG_AMBER_MULTIPLIER = 1.5;

/**
 * Server-side per-user TTL cache window for dashboard endpoints. The
 * frontend's TanStack Query `staleTime` should match this so the two
 * staleness windows align.
 */
export const DASHBOARD_CACHE_TTL_MS = 30_000;

/**
 * FDR growth chart default window. The Phase 3 dashboard Row 3 + the FDR
 * page both call `/fdr/growth?months=N` with this value.
 */
export const FDR_DEFAULT_GROWTH_MONTHS = 12;

/**
 * FDR upcoming-maturities horizon. The dashboard Row 3 and the FDR page
 * both call `/fdr/upcoming?days=N` with this value.
 */
export const FDR_DEFAULT_MATURITY_HORIZON_DAYS = 90;
